export default {"src":"/_next/static/media/StarklingsLogo.7bfdf125.svg","height":100,"width":102};